import React from 'react';
import 'keen-slider/keen-slider.min.css';
import { mediaDir } from 'appolloConfig';
import { useKeenSlider } from 'keen-slider/react';
import { ProductMedia } from 'types/product/product';
import useStyle from './productCarousel.style';

interface ProductCarouselType {
  productName: string;
  productMedia: ProductMedia[];
}

export const ProductCarousel = ({
  productName,
  productMedia
}: ProductCarouselType) => {
  const classes = useStyle();
  const [sliderRef] = useKeenSlider(
    {
      loop: productMedia.length > 1
    },
    [
      slider => {
        let timeout: ReturnType<typeof setTimeout>;
        let mouseOver = false;
        function clearNextTimeout() {
          clearTimeout(timeout);
        }
        function nextTimeout() {
          clearTimeout(timeout);
          if (mouseOver) return;
          timeout = setTimeout(() => {
            slider.next();
          }, 2000);
        }
        slider.on('created', () => {
          slider.container.addEventListener('mouseover', () => {
            mouseOver = true;
            clearNextTimeout();
          });
          slider.container.addEventListener('mouseout', () => {
            mouseOver = false;
            nextTimeout();
          });
          nextTimeout();
        });
        slider.on('dragStarted', clearNextTimeout);
        slider.on('animationEnded', nextTimeout);
        slider.on('updated', nextTimeout);
      }
    ]
  );

  return (
    <>
      {productMedia.length > 0 && (
        <div ref={sliderRef} className={'keen-slider'}>
          {productMedia.map((image, key) => {
            return (
              <div key={key} className="keen-slider__slide">
                <img
                  className={classes.image}
                  src={mediaDir + image?.url}
                  alt={productName}
                />
              </div>
            );
          })}
        </div>
      )}
    </>
  );
};
